import React from 'react'
import webworkflow from '../../../assets/web-devlopment/webworkflow.png'
import style from '../webmobileworkflow.module.css'

const MobileWorkFlow = () => {
  return (
    <div className={style.maindiv}>
                <div className={`heading headingborder`}>
                Our Mobile App Development Workflow
                </div>
                <div className='d-flex justify-content-center'>
                    <h1 className={style.content}>
                    To design and construct the most advanced and feature-rich mobile apps imaginable, we employ the most up-to-date technical standards, modern business strategies, and unique approaches, all while adopting an agile development strategy. The following are the phases of our development process.
                    </h1>
                </div>
                <div className={style.flowchart}>
                    <div className={style.box1}>
                        <div className={style.subheading}>Strategy & Formulation</div>
                    </div>
                    <div className={style.box2}>
                        <div className={style.subheading}>Designing</div>
                    </div>
                    <div className={style.box3}>
                        <div className={style.subheading}>Testing</div>
                    </div>
                    <div className={style.box4}>
                        <div className={style.subheading}>Idea</div>
                    </div>
                    <div className={style.box5}>
                        <div className={style.subheading}>Analysis &<br/> Planning</div>
                    </div>
                    <div className={style.box6}>
                        <div className={style.subheading}>Development</div>
                    </div>
                    <div className={style.box7}>
                        <div className={style.subheading}>Launch</div>
                    </div>
                    <div className='text-center'>
                        <img src={webworkflow} className={style.flowimage} alt="ReactJs Flow" />
                    </div>
                </div>
            </div>
  )
}

export default MobileWorkFlow